import React, { useState } from "react";

import Header from "../../layout/Header";
import Subheader from "../../layout/Subheader";

import useStyles from "./style";
import { Link } from "react-router-dom";
import {
  calcLengthBtnMenu,
  findTitulo,
  findDynamicReports,
  getUrlControle,
  getURL,
  findModule
} from "../../services/auth";

export function Reports() {
  const classes = useStyles();
  const { menus } = JSON.parse(sessionStorage.getItem('@Capitalle-Menu'));
  const [largerItemLenght, setLargerItemLenght] = useState(0);

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title='Relatórios' />
      <div className={classes.content}>
        <div className={classes.contentHome}>
          {menus.map((menu) => (
            <>
              {menu.controle == 2 && (
                  <Link
                    to={
                      menu.acao == "ProximoControle" || menu.acao == "ControleAnterior" ? getUrlControle(menu.irParaControle) : 
                      menu.acao == "CarregaUrl" ? getURL(menu.moduloId) : '#'}
                    className={classes.cardLink}
                    style={{ width: calcLengthBtnMenu(menu.titulo, setLargerItemLenght, largerItemLenght), backgroundColor: menu.corFundo }}>
                    <span className={classes.cardLinkText} style={{ color: menu.corFonte }}>{menu.titulo}</span>
                  </Link>   
              )}
            </>
          ))}
          {/* {!!findSomePermission(1692, "Consultar") && (
            <Link
              to={getURL("diario")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1692), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1692)}</span>
            </Link>
          )}
          {!!findSomePermission(1701, "Consultar") && (
            <Link
              to={getURL("mensal")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1701), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1701)}</span>
            </Link>
          )}
          {!!findSomePermission(1919, "Consultar") && (
            <Link
              to={getURL("producao")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1919), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1919)}</span>
            </Link>
          )}
          {!!findSomePermission(2509, "Consultar") && (
            <Link
              to={getURL("producaoDiaria")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(2509), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(2509)}</span>
            </Link>
          )}
          {!!findSomePermission(1597, "Consultar") && (
            <Link
              to={getURL("metas")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1597), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1597)}</span>
            </Link>
          )}
          {!!findSomePermission(2267, "Consultar") && (
            <Link
              to={getURL("contasAPagar")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(2267), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(2267)}</span>
            </Link>
          )}
          {!!findSomePermission(2226, "Cadastrar") && (
            <Link
              to={getURL("pontos")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(2226), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(2226)}</span>
            </Link>
          )}
          {!!findSomePermission(2254, "Consultar") && (
            <Link
              to={getURL("comparativo")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(2254), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(2254)}</span>
            </Link>
          )}
          {!!findSomePermission(2405, "Consultar") && (
            <Link
              to={getURL("acumuladoRede")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(2405), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(2405)}</span>
            </Link>
          )}

          {!!findSomePermission(3960, "Consultar") && (
            <Link
              to={getURL("ancoraAntecipacoes")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(3960), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(3960)}</span>
            </Link>
          )}
          {!!findSomePermission(14147, "ExecutarFechamento") && (
            <Link
              to={getURL("fechamentoMensal")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(14147), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(14147)}</span>
            </Link>
          )}
          {!!findSomePermission(1979, "Consultar") && (
            <Link
              to={getURL("dinamicos")}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(1979), setLargerItemLenght, largerItemLenght) }}>
              <span className={classes.cardLinkText}>{findTitulo(1979)}</span>
            </Link>
          )}
          {findDynamicReports().map(x => (
            <Link
              to={getURL("dinamicos") + getDynamicId(x.modulo)}
              className={classes.cardLink}
              style={{ width: calcLengthBtnMenu(findTitulo(x.moduloId), setLargerItemLenght, largerItemLenght) }}>
            <span className={classes.cardLinkText}>{x.titulo}</span>
            </Link>
          ))} */}
        </div>
      </div>
    </div>
  );
}
